module.exports = __webpack_public_path__ + "static/media/IMG_4541.4fa533d3.jpg";